import React from 'react';
import classNames from 'classnames';
import { InputNumber } from 'primereact/inputnumber';
import { useTranslation } from 'react-i18next';
import { DynamicFormFieldProps } from '../../types/types';
import { getDynamicFieldTooltip } from '../../../utils/helper';
import { isAttributeDisabled } from '../../../utils/attribute';

type Props = DynamicFormFieldProps;

export default function NumberInput({
  attribute,
  field,
  fieldState,
}: Props) {
  const { i18n } = useTranslation();

  return (
    <InputNumber
      onValueChange={field.onChange}
      value={field.value}
      inputId={field.name}
      locale={i18n.language}
      minFractionDigits={attribute.decimalsAllowed ? 1 : undefined}
      className={classNames({ 'w-full': true, 'p-invalid': fieldState.error })}
      disabled={isAttributeDisabled(attribute)}
      {...getDynamicFieldTooltip(attribute)}
    />
  );
}
